/**
 * Created by Miguel A G Pinto 02-11-2017.
 */




export class CompanyBean {
  public dbId             : string;//key is the firebaseUserName of the creator
  public name             : string;
  public description      : string;
  public smallDescription : string;
  public kind             : string;
  public phone:             string;
  public website          : string;
  public email            : string;
  public companySympla  :string;
  public workingTime      : string;
  public events   : Event[];
  public instagram: string;
  public whatsapp:string;
  public youtube: string;
  public thumbnail        : string;
  public icon             : string;
  public companyMainThumbnail : string;
  public companyMiddleThumbnail : string;
  public companyIcon: string;
  public thumbnails: string[]=[];
  public companyThumbnailList1: string;
  public companyThumbnailList2: string;
  public companyThumbnailList3: string;
  public companyThumbnailList4: string;
  public companyThumbnailList5: string;
  public companyThumbnailList6: string;
  public companyThumbnailList7: string;
  public companyThumbnailList8: string;
  public latitude: number;
  public longitude: number;
  public addressName: string;
  public addressComplement: string;
  public viplistasHide: boolean= false;
};




// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/beansts/company.bean.ts